import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CheckMark from '@/assets/minty_check.svg';
import { useState } from 'react';

export type SortData = {
	label: string;
	name: string;
};

type SortTileProps = {
	data: SortData[];
	setSelectedSort: (sortName: string) => void;
	selectedSort: string;
};

function SortTiles(props: SortTileProps) {
	const [sortOptionsOpen, setSortOptionsOpen] = useState<boolean>(false);
	return (
		<Box>
			<FlexBox
			width='max-content'
			direction='column'
				sx={{
					
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '8px 0',
					border: `1px solid ${getColor('Gray -2')}`,
					maxHeight:'38px',
					borderRadius: '24px',
					background: getColor(''),
					'.sortDropdown':{
						opacity:0,
						transition:'all 300ms ease', 
						width:'100%',
						height:'0px',
						position:'relative',
						zIndex:-1
					},
					'&:hover':{
						background:getColor('Minty -3'),
						'.sortDropdown':{
							opacity:1,
							height:'max-content',
							zIndex:7
						}
					}
				}}
				
			>
				<FlexBox justifyContent={'space-between'} alignItems='center' width='100%' sx={{padding:'0 16px'}}>
				<LencoTypography
					sx={{
						
						...getStyle('Small_Medium'),
						color: getColor('Minty +1'),
						marginRight: '48px',
						
						whiteSpace: 'nowrap',
					}}
				>
					{props.selectedSort}
				</LencoTypography>
				<CheckMark />
				</FlexBox>
				<Box sx={{pt:'16px',width:'100%'}}>
				<Box
				className='sortDropdown'
					sx={{
						background: getColor(''),
						border: `1px solid ${getColor('Minty 0')}`,
						borderRadius: '24px',
						padding: '16px 0',
						width:'100%',
					}}
				>
					{props?.data.map((sorts) => {
						return (
							<Box
								key={sorts.name}
								sx={{
									color:
												props.selectedSort == sorts.label
													? getColor('Minty 0')
													: getColor('Gray -1'),
									'&:hover': {
										background: getColor('Minty -6'),
										transition: 'background 0.5s ease',
										color:getColor('Minty 0')
									},
									
									padding:'0 20px'
								}}
							>
								<FlexBox
									sx={{
										justifyContent: 'space-between',
										alignItems: 'center',
										padding: '8px 0',
										borderBottom: `1px solid ${getColor('Minty -3')}`,

										width:'100%'
									}}
									onClick={() => props.setSelectedSort(sorts.label)}
								>
									<LencoTypography
										sx={{
										width:'100%',

											...getStyle('Small_Medium'),
											
											marginRight: '8px',
										}}
									>
										{sorts.label}
									</LencoTypography>
									{props.selectedSort == sorts.label && <CheckMark />}
								</FlexBox>
							</Box>
						);
					})}
				</Box>
				</Box>
			</FlexBox>
				
		</Box>
	);
}

export default SortTiles;
